export const LocaleNames = {
  enUS: 'English',
  deDE: 'Deutsch',
  esES: 'Espa\u00f1ol',
  frFR: 'Fran\u00e7ais',
  itIT: 'Italiano',
  koKR: '\ud55c\uad6d\uc5b4',
  plPL: 'Polski',
  ptBR: 'Portugu\u00eas',
  ruRU: '\u0420\u0443\u0441\u0441\u043a\u0438\u0439',
  zhCN: '\u7b80\u4f53\u4e2d\u6587',
  zhTW: '\u7e41\u9ad4\u4e2d\u6587'
}

export const Quality = {
  LOW: 0,
  NORMAL: 1,
  SUPERIOR: 2,
  MAGIC: 3,
  RARE: 4,
  SET: 5,
  UNIQUE: 6,
  RUNEWORD: 7,
  CRAFTED: 8
}
export const Color = {
  WHITE: 0,
  RED: 1,
  GREEN: 2,
  BLUE: 3,
  GOLD: 4,
  GRAY: 5,
  BLACK: 6,
  GOLD2: 7,
  ORANGE: 8,
  YELLOW: 9,
  GREEN2: 10,
  PURPLE: 11,
  GREEN3: 12,
  BROWN: 13
}

export function getStoredValue(key, defaultValue, session = false) {
  try {
    const item = (
      session ? window.sessionStorage : window.localStorage
    ).getItem(key)
    return item != null
      ? JSON.parse(item)
      : typeof defaultValue === 'function'
      ? defaultValue()
      : defaultValue
  } catch (error) {
    console.error(error)
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue
  }
}

export function removedStoredValue(key, session = false) {
  try {
    ;(session ? window.sessionStorage : window.localStorage).removeItem(key)
  } catch (error) {
    console.error(error)
  }
}

export function setStoredValue(key, value, session = false) {
  try {
    ;(session ? window.sessionStorage : window.localStorage).setItem(
      key,
      JSON.stringify(value)
    )
  } catch (error) {
    console.error(error)
  }
}

export function getCookies() {
  const result = []
  for (const cookie of document.cookie.split(';')) {
    const parts = cookie.split('=')
    if (parts.length === 2) {
      result[parts[0].trim()] = decodeURIComponent(parts[1].trim())
    }
  }
  return result
}

/* CONFIGURATION */

export const Game = 'd2'

export const GameVersion = 100

export const BuildInfoLevel = 3
export const MaxProfileSets = 24
export const MaxProfileSetName = 36

//export const getIconPath = id => `/icons/${id}.png`;
//export const getTypeIconsPath = type => `/itemtypes/${type}.png`;
//export const getApiPath = action => `/${action}`;

const parts = window.location.pathname.split('/')
export const PD2 = parts.includes('d2planner-pd2')

export const HasPTR = false

const PTR = HasPTR && parts.includes('d2planner-ptr')
// this stuff won't work because this code is run before the page actually loads
/*if (!parts.includes("d2planner")) {
  // this is not the planner so we have to check embeds
  for (const el of document.querySelectorAll(".d2planner-build")) {
    if (el.getAttribute("data-d2planner-ptr")) {
      PTR = true;
    }
  }
}*/
export { PTR }

//const isDev = (process.env.NODE_ENV === 'development');
//const isTest = !isDev && process.env.PUBLIC_URL.includes('d2planner-test');

export const getProfilePath = (id) =>
  PD2
    ? `/d2/d2planner-pd2/${id}`
    : PTR
    ? `/d2/d2planner-ptr/${id}`
    : `/d2/d2planner/${id}`
export const getAssetsPath = (path) =>
  process.env.PUBLIC_URL + `/game/${path}?${process.hashes?.[path] || ''}`
// export const getApiPath = /*isDev ? (action => `/${action === 'account' ? action : 'd2' + action}`) :*/
//   (isTest ? (action => `https://d2planner-test.maxroll.gg/${action}`) : (action => `https://d2planner.maxroll.gg/${action}`));
// export const getStaticApiPath = /*isDev ? (action => `/${action === 'account' ? action : 'd2' + action}`) :*/
//   (isTest ? (action => `https://d2planner-test.maxroll.gg/d2planner-data/${action}`) : (action => `https://d2planner.maxroll.gg/d2planner-data/${action}`));

export const getPlannerUrl = () => {
  const productionUrl = `https://planners.maxroll.gg`
  const stagingUrl = `https://planners-test.maxroll.gg`
  if (!window) {
    return productionUrl
  }
  const hostname = window.location.hostname
  const isLocal = hostname === 'localhost'
  const isStaging = hostname.endsWith('-staging.maxroll.gg')
  return isStaging ? stagingUrl : productionUrl
}

export const getApiPath = (action) => {
  const plannerUrl = getPlannerUrl()
  return `${plannerUrl}/${action}`
}

let _isEmbed = null

export const isEmbed = () => _isEmbed
export const EMBED_setEmbed = () => (_isEmbed = true)
